import { FB_URL } from "@/components/site/social";

const services = [
  {
    id: "coaching",
    num: "01",
    title: "Life- & Mastercoaching",
    body: "Vi flytter energien fra analyse til handling. Fra ‘hvorfor skete det?’ til ‘hvad gør jeg nu?’.",
  },
  {
    id: "stress",
    num: "02",
    title: "Stresscoaching",
    body: "Få redskaberne til at finde ro og retning, når livet føles uoverskueligt.",
  },
  {
    id: "nada",
    num: "03",
    title: "NADA-akupunktur",
    body: "Skab balance i dit nervesystem og giv din mentale proces de bedste betingelser gennem øreakupunktur.",
  },
];

const ServiceCard = ({ s }) => (
  <article
    data-testid={`service-card-${s.id}`}
    className="service-card reveal flex flex-col"
  >
    <span className="num">{s.num}</span>
    <h3 className="font-serif text-cm-ink text-2xl sm:text-[1.6rem] leading-snug mt-6">
      {s.title}
    </h3>
    <div className="w-10 h-px bg-cm-rose mt-6 opacity-70" />
    <p className="mt-6 text-cm-ink-soft leading-relaxed text-[0.98rem]">
      {s.body}
    </p>
    <a
      href={FB_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`service-cta-${s.id}`}
      className="mt-10 self-start text-xs tracking-[0.24em] uppercase text-cm-ink hover:text-cm-rose transition-colors flex items-center gap-2"
    >
      Læs mere
      <span aria-hidden>→</span>
    </a>
  </article>
);

const SparringCard = () => (
  <article
    data-testid="service-card-sparring"
    className="service-card reveal"
  >
    <div className="grid md:grid-cols-12 gap-8 md:gap-12 lg:gap-16">
      {/* Left column — title block */}
      <div className="md:col-span-5 flex flex-col">
        <span className="num">04</span>
        <h3 className="font-serif text-cm-ink text-2xl sm:text-[1.6rem] lg:text-[1.85rem] leading-snug mt-6">
          Sparringspartner
        </h3>
        <div className="w-10 h-px bg-cm-rose mt-6 opacity-70" />
        <p className="mt-6 text-cm-ink-soft leading-relaxed text-[0.98rem]">
          Jeg er din nærværende og ærlige sparringspartner. Sammen undersøger
          vi det, der fylder — uden masker og uden behov for at præstere.
        </p>
        <a
          href={FB_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="service-cta-sparring"
          className="mt-8 md:mt-auto md:pt-10 self-start text-xs tracking-[0.24em] uppercase text-cm-ink hover:text-cm-rose transition-colors flex items-center gap-2"
        >
          Læs mere
          <span aria-hidden>→</span>
        </a>
      </div>

      {/* Right column — body content */}
      <div className="md:col-span-7 md:border-l md:border-cm-line md:pl-12 lg:pl-16 space-y-5 text-cm-ink-soft leading-relaxed text-[0.98rem]">
        <p>
          Jeg stiller de spørgsmål, der udfordrer dine blinde vinkler og hjælper
          dig med at mærke, hvad der faktisk er vigtigt for dig.
        </p>
        <p className="text-cm-ink">Sparring hos mig er for dig, der ønsker:</p>
        <ul className="space-y-3">
          <li className="flex gap-3">
            <span className="mt-2 w-1.5 h-1.5 rounded-full bg-cm-rose flex-shrink-0" />
            <span>Mere klarhed i dine valg og retning (privat og erhverv)</span>
          </li>
          <li className="flex gap-3">
            <span className="mt-2 w-1.5 h-1.5 rounded-full bg-cm-rose flex-shrink-0" />
            <span>Et fortroligt rum til refleksion uden filter</span>
          </li>
          <li className="flex gap-3">
            <span className="mt-2 w-1.5 h-1.5 rounded-full bg-cm-rose flex-shrink-0" />
            <span>Større selvforståelse og ro til at handle autentisk</span>
          </li>
        </ul>
        <p className="font-serif italic text-cm-ink text-base sm:text-lg leading-relaxed pt-2">
          Det vigtigste for mig er, at du føler dig mødt som menneske — ikke som
          et projekt.
        </p>
      </div>
    </div>
  </article>
);

export default function Services() {
  return (
    <section
      id="ydelser"
      data-testid="services-section"
      className="relative py-16 sm:py-24 lg:py-40 bg-cm-surface"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-10 lg:px-16">
        <div className="max-w-3xl reveal">
          <span className="ornament" data-testid="services-eyebrow">
            <em>Mine ydelser</em>
          </span>
          <h2
            data-testid="services-headline"
            className="font-serif text-cm-ink mt-8 text-[1.85rem] sm:text-4xl lg:text-[3rem] leading-[1.16] sm:leading-[1.12] tracking-[-0.005em]"
          >
            Dine veje ind — én fælles{" "}
            <span className="marker">retning</span>.
          </h2>
          <p className="mt-6 text-cm-ink-soft text-base sm:text-lg leading-relaxed max-w-xl">
            Du vælger det, der møder dig dér, hvor du står. Sammen finder vi det
            rette tempo.
          </p>
        </div>

        {/* Top row — 3 cards on desktop, stacked on mobile */}
        <div className="mt-16 sm:mt-20 grid md:grid-cols-3 gap-4 sm:gap-6">
          {services.map((s) => (
            <ServiceCard key={s.id} s={s} />
          ))}
        </div>

        {/* Featured wide card — full width spanning the row on desktop */}
        <div className="mt-4 sm:mt-6">
          <SparringCard />
        </div>
      </div>
    </section>
  );
}
